module.exports = __webpack_public_path__ + "img/megahobby_expo.1387440d.png";